exports = module.exports = require("/Users/jomurgel/broadway/www/kaiser-family-foundation/wp-content/themes/kaiser-foundation-2016/build/apps/datacenter/node_modules/css-loader/cssToString.js")();
exports.push([module.id, "div.datamaps-legend{left:0;width:100%;padding:25px 25px 0;box-sizing:border-box;display:block;clear:both}div.datamaps-legend .key{float:left;list-style:none;width:25%;display:block;padding:0 10px 0 30px;position:relative;box-sizing:border-box;font-size:12px;font-weight:700;font-family:Arial,Helvetica,sans-serif}div.datamaps-legend .data-icon{height:20px;width:20px;top:-1px;left:0;position:absolute}div.datamaps-legend .data-background{height:20px;width:20px;top:2px;left:3px;position:absolute;background:#e7e7e7}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!./styles/datamap-style.css
 ** module id = 6
 ** module chunks = 0 1
 **/